import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../Modal';
import * as modal from '../../reducers/modalReducer';
import RaisedButton from 'material-ui/RaisedButton';
import styled from 'styled-components';

import { HeaderDiv } from '../../modals';
import { ACCENT_COLOR } from '../../config/colors'

const styles = {
  closeIcon: { "position":"absolute",top:0,"right":"0","margin":"8px 5px 0 0" },
  labelStyle: {fontWeight:700}
};

class UploadInfoModal extends Component {
    isNextBtnClicked: false;
    modalStyle = this.props.isSuccess ? { border: '3px solid #' + this.props.secondaryColor } : { border: '3px solid ' + ACCENT_COLOR };

    componentWillMount() {
      if (!this.props.isSuccess) return;
      setTimeout(() => {
          this.onCloseRequest();
      }, 1000)
    }

    onCloseRequest = () => {
      if (this.isNextBtnClicked) return;
        this.props.hideModal();
    }

    handleNextClick = () => {
        this.isNextBtnClicked = true;
        this.props.hideModal();
    }

  render() {
    const text = this.props.error ? 'UPLOAD FAILED' : 'UPLOAD SUCCESSFUL';
    const color = this.props.error ? ACCENT_COLOR : `#` +this.props.secondaryColor;
    return (
      <Modal
        style={this.modalStyle}
        overlayTop={0}
        paddingTop={100}
        closeOnOutsideClick={true}
        isOpened={true}
        onClose={this.onCloseRequest}>
        <ModalWrapperDiv>
            <HeaderDiv color={color}>{text}</HeaderDiv>
              <ButtonsWrapperDiv>
                 <RaisedButton
                    onClick={this.handleNextClick}
                    backgroundColor={`#` + this.props.secondaryColor}
                    labelColor="#FFF"
                    label="Next"
                    labelStyle={styles.labelStyle}
                  />
              </ButtonsWrapperDiv>
        </ModalWrapperDiv>
       </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      hideModal: () => dispatch(modal.hideModal()),
      openSignUpForm: () => dispatch(modal.openModal({
        modalType: 'SIGNUP_FORM',
        modalProps: {}
      })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadInfoModal);

const ModalWrapperDiv = styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    height: 100%;
    font-family: 'Futura-Bold',  sans-serif;
`;


const ButtonsWrapperDiv = styled.div `
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
`;




// WEBPACK FOOTER //
// ./src/components/UploadInfoModal/UploadInfoModal.jsx